import { Node as ProseMirrorNode } from "@tiptap/pm/model";
import { Editor, JSONContent } from "@tiptap/react";
import { cloneDeep, groupBy } from "lodash-es";
import { findParentNodeOfTypeClosestToPos } from "prosemirror-utils";
import { Node } from "reactflow";
import * as Y from "yjs";

import { getListItemText } from "@/utils";

export const getEditorNodes = (editor: Editor) => {
  const ids: string[] = [];
  const nodes: Node[] = [];
  editor?.state.doc.descendants((node: ProseMirrorNode, pos) => {
    if (node.attrs.blockId && node.type.name == "listItem") {
      const blockId = node.attrs.blockId;
      ids.push(node.attrs.blockId);

      const parentLabel = getListItemText(node);
      const depth = editor.state.doc.resolve(pos).depth;
      const graphNode: Node = {
        id: blockId,
        data: { label: parentLabel, depth, hasChildren: node.childCount > 1 },
        position: { x: 10, y: 10 },
        type: "GraphNode",
        expandParent: false,
        zIndex: depth + 10,
        style: { width: 200, height: 80 },
      };
      // console.log("node.childCount", node.childCount);
      const parent = findParentNodeOfTypeClosestToPos(
        editor.state.doc.resolve(pos),
        editor.schema.nodes.listItem
      );
      const parentId = parent?.node.attrs.blockId;
      if (parentId) {
        graphNode.parentNode = parentId;
        graphNode.extent = "parent";
        graphNode.position = { x: 10, y: 50 };
      } else {
        graphNode.parentNode = null;
        graphNode.extent = null;
      }
      nodes.push(graphNode);
    }
  });
  return { ids, nodes };
};

export function getJsonBlockIds(data: JSONContent[]): string[] {
  const blockIds = new Set<string>();

  function traverse(content: JSONContent[]) {
    for (const item of content) {
      if (item.type === "listItem" && "attrs" in item && item.attrs.blockId) {
        blockIds.add(item.attrs.blockId);
      }
      if (item.content) {
        traverse(item.content);
      }
    }
  }

  traverse(data);

  return Array.from(blockIds);
}

export const setNodeLoading = (id: string, nodesMap: Y.Map<Node> | undefined, loading: boolean) => {
  const node = nodesMap?.get(id);
  if (node) nodesMap?.set(id, { ...node, data: { ...node.data, loading: loading } });
};
